import { Controller } from "@hotwired/stimulus"
import { MeiliSearch } from "meilisearch"

// Dynamic add/remove data attributes with MeiliSearch autocomplete for keys and values
// Targets: container, template
export default class extends Controller {
  static targets = ["container"]

  connect() {
    const env = document.querySelector('meta[name=env]')?.content || 'development'
    const client = new MeiliSearch({ host: location.protocol + '//' + location.host })
    this.indexKeys = client.index('Plant_autosuggest_keys_' + env)
    this.indexValues = client.index('Plant_autosuggest_values_' + env)
    this.counter = this.containerTarget.querySelectorAll("[data-attr-row]").length

    // listen for clicks outside dropdowns to close them
    this.handleOutsideClick = this.handleOutsideClick.bind(this)
    document.addEventListener("click", this.handleOutsideClick)
  }

  disconnect() {
    document.removeEventListener("click", this.handleOutsideClick)
  }

  handleOutsideClick(event) {
    if (!event.target.closest("[data-dropdown-key]") && !event.target.closest("[data-key-input]")) {
      this.element.querySelectorAll("[data-dropdown-key]").forEach(el => el.innerHTML = "")
    }
    if (!event.target.closest("[data-dropdown-value]") && !event.target.closest("[data-value-input]")) {
      this.element.querySelectorAll("[data-dropdown-value]").forEach(el => el.innerHTML = "")
    }
  }

  addAttribute(event) {
    event.preventDefault()
    const row = this.buildRow("", "", this.counter)
    this.counter++
    this.containerTarget.insertAdjacentHTML("beforeend", row)
  }

  removeAttribute(event) {
    event.preventDefault()
    const row = event.target.closest("[data-attr-row]")
    if (row) row.remove()
  }

  searchKey(event) {
    const input = event.target
    const row = input.closest("[data-attr-row]")
    const dropdown = row.querySelector("[data-dropdown-key]")

    this.indexKeys.search(input.value, { hitsPerPage: 10 }).then(({ hits }) => {
      if (hits.length > 0) {
        dropdown.innerHTML = hits.map(hit =>
          `<a href="" data-action="click->plant-data-attributes#selectKey" data-key-value="${this.escapeHtml(hit.key)}"><div>${this.escapeHtml(hit.key)}</div></a>`
        ).join("")
      } else {
        dropdown.innerHTML = ""
      }
    })
  }

  selectKey(event) {
    event.preventDefault()
    const row = event.target.closest("[data-attr-row]")
    const input = row.querySelector("[data-key-input]")
    const dropdown = row.querySelector("[data-dropdown-key]")
    input.value = event.target.closest("[data-key-value]")?.dataset.keyValue || event.target.textContent
    dropdown.innerHTML = ""
  }

  searchValue(event) {
    const input = event.target
    const row = input.closest("[data-attr-row]")
    const dropdown = row.querySelector("[data-dropdown-value]")
    const keyInput = row.querySelector("[data-key-input]")
    const keyName = keyInput?.value

    if (keyName) {
      this.indexValues.search(input.value, {
        hitsPerPage: 10,
        filter: "key='" + keyName + "'"
      }).then(({ hits }) => {
        if (hits.length > 0) {
          dropdown.innerHTML = hits.map(hit =>
            `<a href="" data-action="click->plant-data-attributes#selectValue" data-val="${this.escapeHtml(hit.value)}"><div>${this.escapeHtml(hit.value)}</div></a>`
          ).join("")
        } else {
          dropdown.innerHTML = ""
        }
      })
    }
  }

  selectValue(event) {
    event.preventDefault()
    const row = event.target.closest("[data-attr-row]")
    const input = row.querySelector("[data-value-input]")
    const dropdown = row.querySelector("[data-dropdown-value]")
    input.value = event.target.closest("[data-val]")?.dataset.val || event.target.textContent
    dropdown.innerHTML = ""
  }

  buildRow(key, value, index) {
    return `<div class="row row-gutters responsive-sm mb-4" data-attr-row="${index}">
      <div class="col-30 dropdown-wrapper">
        <input data-key-input
          name="plant[data][][key]"
          value="${this.escapeHtml(key)}"
          type="text"
          class="input-text"
          placeholder="Data label / key"
          required
          data-action="focus->plant-data-attributes#searchKey input->plant-data-attributes#searchKey"
        />
        <div data-dropdown-key class="dropdown text-left"></div>
      </div>
      <div class="col-60 dropdown-wrapper">
        <input data-value-input
          name="plant[data][][value]"
          value="${this.escapeHtml(value)}"
          type="text"
          class="input-text"
          placeholder="Data / value"
          data-action="focus->plant-data-attributes#searchValue input->plant-data-attributes#searchValue"
        />
        <div data-dropdown-value class="dropdown text-left"></div>
      </div>
      <div class="col-10 text-right">
        <a class="btn-icon-clear-danger mr-4" data-action="click->plant-data-attributes#removeAttribute" href="">
          <svg class="icon icon-gray"><use href="/icons/__remixicon.sprite.svg?v=491#delete-bin-line"/></svg>
        </a>
      </div>
    </div>`
  }

  escapeHtml(str) {
    if (!str) return ""
    const div = document.createElement("div")
    div.textContent = str
    return div.innerHTML
  }
}
